import { ProductTypes } from '../main/constants/ProductTypes';
import { GaugesNotifications } from '../models/GaugesNotifications';
import {
    retrieveStoredDataFromLocalStorage,
    GAUGES_NOTIFICATIONS_STORE_KEY,
    storeDataToLocalStorage,
} from '../helpers/localStorageHelper';
import { ActiveProduct } from '../models/ActiveProduct';

export interface IGaugesNotificationData {
    type: ProductTypes;
    notifications: number[];
}

export type MapGaugesNotifications = Map<ProductTypes, GaugesNotifications>;

export const getGaugesNotificationData = (activeProducts: ActiveProduct[]): Map<ProductTypes, GaugesNotifications> => {
    let notificationsProducts: MapGaugesNotifications = new Map();
    let retrievedData =
        retrieveStoredDataFromLocalStorage<IGaugesNotificationData[]>(GAUGES_NOTIFICATIONS_STORE_KEY) || [];

    for (let indexProduct = 0; indexProduct < activeProducts.length; ++indexProduct) {
        const product = activeProducts[indexProduct];
        const storedNotification = retrievedData.filter(storedNot => product.type === storedNot.type)[0] || {
            type: product.type,
            notifications: [],
        };

        notificationsProducts.set(product.type, new GaugesNotifications(product, storedNotification));
    }

    return notificationsProducts;
};

export const storeGaugesNotificationData = (gaugesNotifications: GaugesNotifications): void => {
    let hasItemOnLocalStorage = false;
    let retrievedData =
        retrieveStoredDataFromLocalStorage<IGaugesNotificationData[]>(GAUGES_NOTIFICATIONS_STORE_KEY) || [];

    for (let notificationIndex = 0; notificationIndex < retrievedData.length; ++notificationIndex) {
        const notificationData = retrievedData[notificationIndex];

        if (gaugesNotifications.type === notificationData.type) {
            hasItemOnLocalStorage = true;
            retrievedData[notificationIndex] = gaugesNotifications.serialize();
        }
    }

    if (!hasItemOnLocalStorage) {
        retrievedData.push(gaugesNotifications.serialize());
    }

    storeDataToLocalStorage<IGaugesNotificationData[]>(GAUGES_NOTIFICATIONS_STORE_KEY, retrievedData);
};
